import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { MaxThumbnailHeight, MaxThumbnailWidth } from "assets/jss/common-styles";

const i3by4 = Math.floor(3 / 4);

const imageStyle = (theme: Theme) => createStyles({
    rounded: {
        borderRadius: "50%"
    },

    square: {
        width: MaxThumbnailHeight,
        height: MaxThumbnailHeight,

        "&.auto": {
            width: "inherits",
            height: "inherits"
        },
        "&.sm": {
            width: Math.floor(MaxThumbnailHeight / 2),
            height: Math.floor(MaxThumbnailHeight / 2)
        },
        "&.xs": {
            width: Math.floor(MaxThumbnailHeight / 3),
            height: Math.floor(MaxThumbnailHeight / 3)
        },
        "&.icon": {
            width: Math.floor(MaxThumbnailHeight / 4),
            height: Math.floor(MaxThumbnailHeight / 4)
        }
    },

    wide: {
        width: MaxThumbnailWidth,
        height: MaxThumbnailHeight,

        "&.auto": {
            width: "inherits",
            height: "inherits"
        },
        "&.sm": {
            width: Math.floor(MaxThumbnailWidth / 2),
            height: Math.floor(MaxThumbnailHeight / 2)
        },
        "&.xs": {
            width: Math.floor(MaxThumbnailWidth / 3),
            height: Math.floor(MaxThumbnailHeight / 3)
        },
        "&.icon": {
            width: Math.floor(MaxThumbnailWidth / 4),
            height: Math.floor(MaxThumbnailHeight / 4)
        }
    },

    portrait: {
        width: Math.floor(MaxThumbnailHeight * i3by4),
        height: MaxThumbnailHeight,
        "&.auto": {
            width: "inherits",
            height: "inherits"
        },
        "&.sm": {
            width: Math.floor(MaxThumbnailHeight / 2 * i3by4),
            height: MaxThumbnailHeight / 2
        },
        "&.xs": {
            width: Math.floor(MaxThumbnailHeight / 3 * i3by4),
            height: MaxThumbnailHeight / 3
        },
        "&.icon": {
            width: Math.floor(MaxThumbnailHeight / 4 * i3by4),
            height: MaxThumbnailHeight / 4
        }
    },

});

export default imageStyle;
